// src/routing/rutas.js (o Routes.jsx)
import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { Global } from "../helpers/Global";
import { PublicLayout } from "../layout/public/PublicLayout";
import { PrivateLayout } from "../layout/private/PrivateLayout";
import { AuthProvider } from "../context/AuthProvider";
import { PrivateRoute } from "./privateRoute";

// Páginas públicas
import { LoginDNI } from "../user/LoginDNI";
import { LoginMail } from "../user/LoginMail";
import { SolicitarResetPassword } from "../user/solicitarResetPassword";
import { ResetearPassword } from "../user/resetearPassword";

// Páginas comunes
import { LogOut } from "../user/logout";
import { InicioPage } from "../pages/inicio";
import { ConfigurarAlertas } from "../alertas/configurarAlertas.jsx";
import NotFound from "../pages/notFound.jsx";

// Jornadas
import { JornadaPage } from "../jornada/jornadaPage";
import { MisJornadasFinalizadas } from "../jornada/misJornadasFinalizadas";
import { ListadoJornadas } from "../jornada/listadoJornadas.jsx";
import { JornadasProceso } from "../jornada/jornadaProceso";
import { CrearJornadaManual } from "../jornada/crearJornadaManual";
import { FinalizarJornadaManual } from "../jornada/finalizarJornadaManual";
import { JornadaCentros } from "../jornada/jornadaCentros.jsx";

// Intervenciones
import { IntervencionPage } from "../intervenciones/intervencionPage";
import { ListadoIntervenciones } from "../intervenciones/listadoIntervenciones.jsx";
import { InterProceso } from "../intervenciones/interProceso.jsx";
import { MisIntervencionesFinalizadas } from "../intervenciones/misIntervencionesFinalizadas";
import { CrearIntervencionManual } from "../intervenciones/crearInterManual";
import { FinalizarInterManual } from "../intervenciones/finalizarInterManual";
import { ParteTrabajoPage } from "../intervenciones/parteTrabajoPage";
import { ListadoPartesManuales } from "../intervenciones/listadoPartesManuales.jsx";

// Partes
import { MisPartesManual } from "../intervenciones/misPartesManual.jsx";
import { ParteTrabajoManualPage } from "../intervenciones/parteTrabajoManualPage";

// Calendario
import { MiCalendario } from "../calendario/miCalendario";
import { CalendarioAdmin } from "../calendario/calendarioAdmin";
import { CrearPlantillaTurno } from "../calendario/crearPlantillaTurno.jsx";
import { PlantillaTurnoAdmin } from "../calendario/plantillaTurnoAdmin.jsx";
import { CalendarioGlobal } from "../calendario/calendarioGlobal.jsx";

// Órdenes
import { CrearOrden } from "../ordenes/crearOrden";
import { OrdenAdmin } from "../ordenes/ordenAdmin";

// Tareas
import { CrearTarea } from "../tareas/crearTarea.jsx";
import { TableroTareasPersonal } from "../tareas/tableroTareasPersonal.jsx";
import { TableroTareasDepartamento } from "../tareas/tableroTareasDepartamento.jsx";
import { DashboardGlobal } from "../tareas/dashboardGlobal.jsx";

// Clientes
import { CrearCliente } from "../clientes/agregarCliente";
import { ClientesAdmin } from "../clientes/clientesAdmin";
import { CentrosEmpleado } from "../clientes/centrosEmpleado.jsx";

// Usuarios
import { GestionUsuarios } from "../user/gestionUsuarios.jsx";
import { RegistrarUsuarioDNI } from "../user/registrarUsuarioDNI";
import { RegistrarUsuarioMail } from "../user/registrarUsuarioMail";
import { Organigrama } from "../user/organigrama";
import { CambiarContrasena } from "../user/cambiarContrasena";

// Departamentos
import { CrearDepartamento } from "../departamentos/crearDepartamento.jsx";
import { DepartamentosAdmin } from "../departamentos/departamentoAdmin.jsx";
import { OrganigramaDepartamentos } from "../departamentos/organigramaDepartamentos.jsx";

// ControlSIL
import { GestionNodoSIL } from "../controlsil/gestionNodoSIL.jsx";
import { CrearReporteSIL } from "../controlsil/crearReporteSIL.jsx";
import { PanelReportesSIL } from "../controlsil/panelReporteSil.jsx";

// Logs
import { LogsAdmin } from "../user/logsAdmin";

export const Rutas = () => {
  const isMail = String(Global?.loginPrimary || "mail").toLowerCase() === "mail";
  const LoginComponent = isMail ? LoginMail : LoginDNI;
  const RegistrarUsuarioComponent = isMail ? RegistrarUsuarioMail : RegistrarUsuarioDNI;

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Rutas públicas */}
          <Route path="/" element={<PublicLayout />}>
            <Route index element={<LoginComponent />} />
            <Route path="login" element={<LoginComponent />} />
            <Route path="olvide-password" element={<SolicitarResetPassword />} />
            <Route path="resetear-password" element={<ResetearPassword />} />
          </Route>

          {/* Rutas privadas */}
          <Route path="/app" element={<PrivateLayout />}>
            {/* Comunes */}
            <Route index element={<PrivateRoute><InicioPage /></PrivateRoute>} />
            <Route path="inicio" element={<PrivateRoute><InicioPage /></PrivateRoute>} />
            <Route path="intervencion" element={<PrivateRoute><IntervencionPage /></PrivateRoute>} />
            <Route path="misIntervenciones" element={<PrivateRoute><MisIntervencionesFinalizadas /></PrivateRoute>} />
            <Route path="misIntervenciones/:ticajeId/parte" element={<PrivateRoute><ParteTrabajoPage /></PrivateRoute>} />
            <Route path="jornada" element={<PrivateRoute><JornadaPage /></PrivateRoute>} />
            <Route path="misJornadas" element={<PrivateRoute><MisJornadasFinalizadas /></PrivateRoute>} />
            <Route path="miCalendario" element={<PrivateRoute><MiCalendario /></PrivateRoute>} />
            <Route path="centrosInfo" element={<PrivateRoute><CentrosEmpleado /></PrivateRoute>} />
            <Route path="cambiarContrasena" element={<PrivateRoute><CambiarContrasena /></PrivateRoute>} />
            <Route path="misAlertas" element={<PrivateRoute><ConfigurarAlertas /></PrivateRoute>} />
            <Route path="logout" element={<PrivateRoute><LogOut /></PrivateRoute>} />

            {/* Intervenciones */}
            <Route path="listadoIntervenciones" element={<PrivateRoute modulo="intervenciones"><ListadoIntervenciones /></PrivateRoute>} />
            <Route path="interProceso" element={<PrivateRoute modulo="intervenciones"><InterProceso /></PrivateRoute>} />
            <Route path="crearIntervencionManual" element={<PrivateRoute modulo="intervenciones"><CrearIntervencionManual /></PrivateRoute>} />
            <Route path="finalizarInterManual" element={<PrivateRoute modulo="intervenciones"><FinalizarInterManual /></PrivateRoute>} />
            <Route path="misPartesManuales" element={<PrivateRoute modulo="intervenciones"><MisPartesManual /></PrivateRoute>} />
            <Route path="listadoPartesManuales" element={<PrivateRoute modulo="intervenciones"><ListadoPartesManuales /></PrivateRoute>} />
            <Route path="misPartesManuales/:id" element={<PrivateRoute modulo="intervenciones"><ParteTrabajoManualPage /></PrivateRoute>} />

            {/* Jornadas */}
            <Route path="listadoJornadas" element={<PrivateRoute modulo="jornadas"><ListadoJornadas /></PrivateRoute>} />
            <Route path="jornadasProceso" element={<PrivateRoute modulo="jornadas"><JornadasProceso /></PrivateRoute>} />
            <Route path="crearJornadas" element={<PrivateRoute modulo="jornadas"><CrearJornadaManual /></PrivateRoute>} />
            <Route path="finalizarJornadas" element={<PrivateRoute modulo="jornadas"><FinalizarJornadaManual /></PrivateRoute>} />
            <Route path="jornadasCentro" element={<PrivateRoute modulo="jornadas"><JornadaCentros /></PrivateRoute>} />

            {/* Calendario */}
            <Route path="calendarioAdmin" element={<PrivateRoute modulo="calendario"><CalendarioAdmin /></PrivateRoute>} />
            <Route path="crearPlantillaTurno" element={<PrivateRoute modulo="calendario"><CrearPlantillaTurno /></PrivateRoute>} />
            <Route path="plantillaTurnoAdmin" element={<PrivateRoute modulo="calendario"><PlantillaTurnoAdmin /></PrivateRoute>} />
            <Route path="global" element={<PrivateRoute modulo="calendario"><CalendarioGlobal /></PrivateRoute>} />

            {/* Órdenes */}
            <Route path="crearOrden" element={<PrivateRoute modulo="ordenes"><CrearOrden /></PrivateRoute>} />
            <Route path="ordenAdmin" element={<PrivateRoute modulo="ordenes"><OrdenAdmin /></PrivateRoute>} />

            {/* Clientes */}
            <Route path="crearCliente" element={<PrivateRoute modulo="clientes"><CrearCliente /></PrivateRoute>} />
            <Route path="clientesAdmin" element={<PrivateRoute modulo="clientes"><ClientesAdmin /></PrivateRoute>} />

            {/* Tareas */}
            <Route path="crearTarea" element={<PrivateRoute modulo="tareas"><CrearTarea /></PrivateRoute>} />
            <Route path="tableroPersonal" element={<PrivateRoute modulo="tareas"><TableroTareasPersonal /></PrivateRoute>} />
            <Route path="tableroDepartamento" element={<PrivateRoute modulo="tareas"><TableroTareasDepartamento /></PrivateRoute>} />
            <Route path="dashboard" element={<PrivateRoute modulo="tareas"><DashboardGlobal /></PrivateRoute>} />

            {/* Usuarios */}
            <Route path="crearUsuario" element={<PrivateRoute modulo="usuarios"><RegistrarUsuarioComponent /></PrivateRoute>} />
            <Route path="usuariosAdmin" element={<PrivateRoute modulo="usuarios"><GestionUsuarios /></PrivateRoute>} />
            <Route path="organigrama" element={<PrivateRoute modulo="usuarios"><Organigrama /></PrivateRoute>} />

            {/* Departamentos */}
            <Route path="crearDepartamento" element={<PrivateRoute modulo="departamentos"><CrearDepartamento /></PrivateRoute>} />
            <Route path="departamentosAdmin" element={<PrivateRoute modulo="departamentos"><DepartamentosAdmin /></PrivateRoute>} />
            <Route path="organigramaDepartamentos" element={<PrivateRoute modulos={["departamentos", "tareas"]}><OrganigramaDepartamentos /></PrivateRoute>} />

            {/* ControlSIL */}
            <Route path="gestionControlSIL" element={<PrivateRoute modulo="silcontrol" soloAdmin><GestionNodoSIL /></PrivateRoute>} />
            <Route path="crearReporteSIL" element={<PrivateRoute modulo="silcontrol"><CrearReporteSIL /></PrivateRoute>} />
            <Route path="panelControlSIL" element={<PrivateRoute modulo="silcontrol"><PanelReportesSIL /></PrivateRoute>} />

            {/* Logs */}
            <Route path="logs" element={<PrivateRoute modulo="logs"><LogsAdmin /></PrivateRoute>} />

            {/* 404 dentro de /app */}
            <Route path="*" element={<NotFound />} />
          </Route>

          {/* 404 global */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Rutas;